import { useQuery } from "@tanstack/react-query";
import { getUnsubsList, getUnsubsListSearchParams } from "apis/member/unsubs_list_api";
import CardFixed from "components/Card/CardFixed";
import { SubLine, simpleAlert } from "components/CommonLib/CommonLib";
import Loading from "components/Loading/Loading/Loading";
import NormalBtn from "components/NewButton/NormalBtn";
import { globalModalOff, globalModalOn } from "modules/actions/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MsgPreviewModal from "../Modal/MsgPreviewModal";
import SearchCondition from "./SearchCondition";
import UnsubsListResultTable from "./UnsubsListResultTable";
import { useUnsubsListStore } from "./modules/store/unsubsListState";

const UnsubsListView = () => {
  const storesDispatch = useDispatch();
  // 전역 상태 관리
  const {
    unsubsListSearchParams: searchParams,
    setSearchParams,
    unsubsListPage: page,
    setPage,
    resetSearchParams,
  } = useUnsubsListStore();

  // 페이지 상태 관리
  const [searchResult, setSearchResult] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [resetFlag, setResetFlag] = useState(false);

  // API 상태 관리
  const [isGetUnsubsList, setIsGetUnsubsList] = useState(false);
  const queryData = { page: page, searchParams: searchParams };

  // [GET] 수신거부 목록 검색 조건 및 권한 가져오기 << 현재 안 쓰는 중
  const { data: firstSearchParamData } = useQuery({
    queryKey: ["unsubsList", "firstSearchParam"],
    queryFn: () => getUnsubsListSearchParams(),
    enabled: true,
    retry: false,
    cacheTime: 0,

    onSuccess: (res) => {
      // 현재 msg가 같이 와서 Error처럼 표시되는 중 추후 확인 해야 함!
      // if (res.data.msg) {
      //   simpleAlert(storesDispatch, "알림", res.data.msg);
      // }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });

  // [GET] 수신거부 목록 리스트 가져오기
  const { isFetching, data: unsubsList } = useQuery({
    queryKey: ["unsubsList", queryData],
    queryFn: () => getUnsubsList(queryData),
    enabled: isGetUnsubsList,
    retry: false,
    cacheTime: 0,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
    onSettled: () => {
      setIsGetUnsubsList(false);
    },
  });

  // 수신 거부 목록 검색
  const onClickSearch = async (page) => {
    setPage(page);
    setIsGetUnsubsList(true);
  };

  const onModalDone = (res) => {
    console.log(res);
    storesDispatch(globalModalOff());
  };

  const openModal = (order, param) => {
    let Modal;
    if (order === "show") {
      Modal = <MsgPreviewModal modalParam={param} onModalDone={onModalDone} />;
    }
    storesDispatch(
      globalModalOn({
        show: true,
        title: param.title,
        Content: Modal,
      }),
    );
  };

  // API 받아온 데이터 세팅
  useEffect(() => {
    // 수신 거부 목록 리스트
    if (unsubsList) {
      setSearchResult(unsubsList.data.data);
      setTotalPage(unsubsList.data.total_page);
    }
  }, [unsubsList]);

  // 첫 페이지 진입 시 검색 결과를 가져오기
  useEffect(() => {
    setIsGetUnsubsList(true);
  }, []);

  return (
    <CardFixed
      midDom={
        <div>
          {isFetching && <Loading />}

          <div>
            <SearchCondition
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              resetFlag={resetFlag}
              onClickSearch={onClickSearch}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "0.75rem",
                gap: "0.25rem",
              }}
            >
              <NormalBtn
                search
                theme="white"
                name="초기화"
                onClick={() => {
                  resetSearchParams();
                  setResetFlag(!resetFlag);
                }}
              />

              <NormalBtn
                search
                name="검색"
                onClick={() => {
                  onClickSearch(1);
                }}
              />
            </div>
          </div>

          <SubLine />

          <div style={{ marginTop: "1rem" }}>
            <UnsubsListResultTable
              openModal={openModal}
              searchResult={searchResult}
              curPage={page}
              setCurPage={setPage}
              totalPage={totalPage}
              onClickSearch={onClickSearch}
            />
          </div>
        </div>
      }
      isLoading={false}
      rootStyle={
        {
          // width: "80.437rem",
          // height: "74.875rem",
        }
      }
    />
  );
};
export default UnsubsListView;
